import { APP_CONFIG } from 'services/app-config'

export const CONFIG = {
  api: {
    financials: `${APP_CONFIG.sales_cluster}/v1/locations/tax`,
  },
}
